const DEFAULT_CHILDREN = [{ text: '' }];
const BLOCK_TYPE = {
  IMAGE: 'image',
  IMAGE_BLOCK: 'image_block',
  IMAGE_CAPTION: 'image_caption',
  LIST_BLOCK: 'list',
  LIST_ITEM: 'list_item',
  PARAGRAPH: 'paragraph',
  SPACE: 'space',
  DIVIDER: 'divider',
  VIDEO: 'video',
  HEADING: 'heading',
  LINK: 'link',
  BLOCKQUOTE1: 'blockquote1',
  BLOCKQUOTE2: 'blockquote2',
};

const DEFAULT_PARAGRAPH = {
  type: BLOCK_TYPE.PARAGRAPH,
  children: DEFAULT_CHILDREN,
};

export {
  DEFAULT_CHILDREN,
  BLOCK_TYPE,
  DEFAULT_PARAGRAPH,
};
